import { CssStates, IGrapesJSProjectData } from "../../../interfaces/VisageUI";

const GjsTemplateExitScenario: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"flex-direction":"column",
				"height":"100%",
				"display":"flex",
				"justify-content":"center",
				"align-items":"center",
				"align-content":"center"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[
				"#C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58"
			],
			"style":{
				"width":"50vw",
				"background":"rgba(30,30,30,0.8)",
				"flex-direction":"column",
				"box-shadow":"0vw 0vw 2vw 0vw rgba(30, 30, 30, 1) ",
				"height":"autovw",
				"display":"flex",
				"padding-top":"2.5vw",
				"padding-right":"2.5vw",
				"padding-bottom":"2.5vw",
				"padding-left":"2.5vw",
				"border-top-left-radius":"2vw",
				"border-top-right-radius":"2vw",
				"border-bottom-right-radius":"2vw",
				"border-bottom-left-radius":"2vw"
			}
		},
		{
			"selectors":[
				"#Ce8bd14e9-7db3-44dc-b089-1f8205515070-2"
			],
			"style":{
				"white-space-collapse":"preserve",
				"font-size":"3vw",
				"color":"#ebebeb",
				"font-weight":"700",
				"width":"100%",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[
				"#Cba5c101d-06a5-40e0-8886-e645d7d1750a"
			],
			"style":{
				"background":"linear-gradient(90deg, rgba(247,247,247,1) 0%, RGBA(9,9,121,1) 73%)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#C1362ff1c-358d-4e63-9208-723c76bf99cb"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"margin-top":"1vw",
				"margin-bottom":"0",
				"margin-left":"0",
				"margin-right":"0",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#C0911548b-5491-43c1-8064-f8908552f8de"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"display":"none"
			}
		},
		{
			"selectors":[
				"#C25f2156f-9bc1-4d7b-9ee1-41926dcd34f3"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"100%",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"1vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#C6457d1b3-b96f-42aa-872d-e800aa143c2c"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)",
				"text-align":"center"
			}
		},
		{
			"selectors":[
				"#Cf25c99f6-312b-44bb-8dd3-4b1830d38a66"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"100%",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(70, 70, 70) 0%, rgba(102,102,102,1) 100%)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"1vw"
			}
		},
		{
			"selectors":[
				"#C867415f9-e9a9-4eab-b3e7-6e4dc6005cc0"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(235, 235, 235, 1)",
				"text-align":"center"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"attributes":{
											"id":"C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58",
											"data-action":""
										},
										"components":[
											{
												"type":"e-text",
												"content":"Exit Scenario?",
												"attributes":{
													"id":"Ce8bd14e9-7db3-44dc-b089-1f8205515070-2",
													"data-action":""
												},
												"custom-name":"Title"
											},
											{
												"type":"e-text",
												"name":"Text",
												"content":"If you have finished all items you can exit the scenario.",
												"attributes":{
													"id":"C0911548b-5491-43c1-8064-f8908552f8de",
												},
												"custom-name":"Description"
											},
											{
												"type":"div",
												"attributes":{
													"id":"C1362ff1c-358d-4e63-9208-723c76bf99cb",
													"data-action":""
												},
												"components":[
													{
														"type":"div",
														"name":"Secondary Button",
														"classes":[
															"secondary-cta"
														],
														"attributes":{
															"id":"Cf25c99f6-312b-44bb-8dd3-4b1830d38a66",
															"asset-id":""
														},
														"components":[
															{
																"type":"e-text",
																"name":"Label",
																"content":"Cancel",
																"attributes":{
																	"id":"C867415f9-e9a9-4eab-b3e7-6e4dc6005cc0",
																}
															}
														],
														"custom-name":"Cancel"
													},
													{
														"type":"div",
														"name":"Primary Button",
														"classes":[
															"primary-cta"
														],
														"attributes":{
															"id":"C25f2156f-9bc1-4d7b-9ee1-41926dcd34f3",
															"asset-id":""
														},
														"components":[
															{
																"type":"e-text",
																"name":"Label",
																"content":"Exit Scenario",
																"attributes":{
																	"id":"C6457d1b3-b96f-42aa-872d-e800aa143c2c",
																}
															}
														],
														"__prev-display":"flex",
														"custom-name":"Exit Scenario"
													}
												],
												"custom-name":"Buttons"
											}
										],
										"custom-name":"Dialog UI"
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Exit Scenario"
					},
					"id":"Hy865jwzBLz5G5Ft"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateExitScenario;